<template>
  <v-card flat class="py-4">
    <v-row no-gutters>
      <!-- Left Aside Tabs -->
      <v-tabs
        :vertical="verticalTab"
        v-model="tab"
        class="mr-4 mb-2 shrink tab-no-arrow"
        :style="verticalTab ? 'width: 120px' : ''"
      >
        <v-tab
          v-for="(t, i) in tabs"
          :key="i"
          :disabled="t.disabled"
          :style="verticalTab ? 'height: 28px' : ''"
          :ripple="false"
          class="my-1 justify-start"
        >
          <v-badge dot :value="t.alert">
            {{ t.title }}
          </v-badge>
        </v-tab>
      </v-tabs>
      <!-- Table -->
      <ValidStore v-if="tab == 0" />
      <ValidProduct v-else-if="tab == 1" />
      <BanStore v-else-if="tab == 2" />
      <BanProduct v-else-if="tab == 3" />
      <BanUser v-else-if="tab == 4" />
    </v-row>

    <!-- <p class="mt-3">{{ query.options }}</p> -->
  </v-card>
</template>

<script>
import ValidStore from "./ApprovalTable/ValidStore.vue";
import ValidProduct from "./ApprovalTable/ValidProduct.vue";
import BanStore from "./ApprovalTable/BanStore.vue";
import BanProduct from "./ApprovalTable/BanProduct.vue";
import BanUser from "./ApprovalTable/BanUser.vue";
import admin from "../../services/admin";

export default {
  components: {
    ValidStore,
    ValidProduct,
    BanStore,
    BanProduct,
    BanUser,
  },
  data() {
    return {
      tab: null,
      tabs: [
        { title: "New Store", value: "", alert: false },
        { title: "New Product", value: "newproduct", alert: false },
        { title: "Ban Store", value: "banstore", alert: false },
        { title: "Ban Product", value: "banproduct", alert: false },
        { title: "Ban User", value: "banuser", alert: false },
      ],
    };
  },
  computed: {
    verticalTab() {
      return this.$vuetify.breakpoint.lgAndUp;
    },
  },
  mounted() {
    const tab = this.$route.hash.slice(1);
    if (tab) this.tab = this.tabs.findIndex((_tab) => _tab.value == tab);
    this.getUpdate();
  },
  methods: {
    getUpdate() {
      if (this.tab != 0)
        admin.getStore({ size: 1, valid: false})
          .then(({ stores }) => this.tabs[0].alert = !!stores.length);
      if (this.tab != 1)
        admin.getProduct({ size: 1, valid: false })
          .then(({ products }) => this.tabs[1].alert = !!products.length);
      if (this.tab != 2)
        admin.getReportedStore({ size: 1 })
          .then(({ reports }) => this.tabs[2].alert = !!reports.length);
      if (this.tab != 3)
        admin.getReportedProduct({ size: 1 })
          .then(({ reports }) => this.tabs[3].alert = !!reports.length);
    },
  },
  watch: {
    tab(i, o) {
      if (o == null) return;
      this.tabs[i].alert = false;
      this.$router.push({ hash: this.tabs[i].value });
    },
  },
};
</script>

<style>
</style>